<div class="content-cards content-list"
     [ngClass]="{'see-more': searchType.seeMore, 'own-partnership-list': ownPartnershipsOnly}"
     *ngIf="!loading && user?.typeBusiness === 'company'">

  <div class="page-info" *ngIf="ownPartnershipsOnly">
    <h1>Parcerias Próprias</h1>
    <button class="btn btn-pink" [routerLink]="['/parcerias-exclusivas/cadastrar']">Cadastrar parceria exclusiva</button>
  </div>

  <div
    class="scrolled-wrapper"
    infiniteScroll
    [fromRoot]="true"
    [infiniteScrollContainer]="'.content-cards'"
    [infiniteScrollDistance]="1"
    (scrolled)="scrollSearch.emit()"
  >

    <!-- Online listing -->
    <div class="featured-cards"
         *ngIf="establishmentsOnline.length && !loading && (searchType.online || searchType.seeMore)">
      <div class="title-content">
        <span class="fa fa-wifi"></span>
        <p>Parcerias online</p>
        <a [class.view-less]="searchType.seeMore"
           (click)="searchType.seeMore = !searchType.seeMore"
        >{{ searchType.seeMore ? 'Ver menos' : 'Ver mais'}}<span class="fa fa-angle-right"></span>
        </a>
      </div>

      <div class="grid-content">
        <establishment-card
          *ngFor="let establishment of visibleOnlineEstablishments()"
          [online]="true"
          [establishment]="establishment"
          [userRole]="getUserRole()"
          [loggedUser]="loggedUser"
        ></establishment-card>
      </div>
    </div>
    <!-- / Online listing -->

    <!-- Cashback listing -->
    <cashback-partners
      *ngIf="cashbackPartners.length && !searchType.seeMore"
      [partners]="cashbackPartners"
    ></cashback-partners>
    <!-- / Cashback listing -->

    <!-- Establishment listing -->
    <div class="no-featured-cards" *ngIf="showEstablishments()">
      <div class="title-content">
        <span class="fa fa-map-marker"></span>
        <p>Lojas próximas</p>
        <p>{{searchType.nearSearchLabel}}</p>
      </div>

      <div class="grid-content">
        <establishment-card
          *ngFor="let establishment of establishments"
          [establishment]="establishment"
          [userRole]="getUserRole()"
          [loggedUser]="loggedUser"
        ></establishment-card>

        <p *ngIf="(establishmentsOnline.length || cashbackPartners.length) && !establishments.length && !loading">
          Não encontramos nenhum estabelecimento perto do local indicado.
        </p>
      </div>
    </div>
    <!-- / Establishment listing -->

    <div class="scrolled" *ngIf="scrolling" [ngClass]="{'scrolled-active': scrolling}">
      <div class="loader"><span></span><span></span><span></span></div>
      <p>Carregando</p>
    </div>
  </div>
</div>
